import styled from 'styled-components'

export const PickupWrapper = styled.div`
  position: relative;
  margin-bottom: 400px;

  .submit-button {
    float: right;
    margin: 40px 30px;
  }
`
